// extracted by mini-css-extract-plugin
export var button = "T_cf";
export var categories = "T_c1";
export var footerText = "T_cc";
export var input = "T_bp";
export var map = "T_cS";
export var mapContainer = "T_cR";
export var offered = "T_cP";
export var search = "T_bn";
export var section = "T_d";
export var title = "T_h";